import React, { useEffect, useState } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ECharts, { EChartsReactProps } from 'echarts-for-react';
const moment=require('moment-jalaali');
let dates=[];
let newArr=[]
for(let i=1;i<31;i++){
  let date=moment().subtract(i,'days').format('jYY/jM/jD')
  const arr=dates.unshift(date);
  
 
}
const d=<CalendarMonthIcon/>;


for(let o=0;o<1;o++){
  const hours=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]
  for(let j=0;j<hours.length;j++){
    newArr.push(`${dates[o]} \n ${hours[j]}:00 `)

  }
}



const StChartPacket = ({stats}) => {
  const colors = ['#5470C6', '#91CC75', '#EE6666','orange','purple','gold','green','aqua','black','#66EE75'];
  
const [rumination1,setRumination]=useState([]);
const [standing1,setStanding]=useState([]);
const [packetCounter1,setPacketCounter]=useState([]);
const [batteryLevel1,setBatteryLevel]=useState([]);
const [temprature1,setTemprature]=useState([]);
const [humidity1,setHumidity1]=useState([])
const [chewing1,setChewing]=useState([]);
const [sleeping1,setSleeping]=useState([]);
const [walking1,setWalking]=useState([]);
const [activity1,setActivity]=useState([]);
const [unrest1,setUnrest]=useState([]);
const [ti,setTi]=useState([])
const [timeformat,setTimeFormat]=useState([])
useEffect(()=>{
  const ruminations=stats&&stats.map(item=>{
    const {rumination}=item;
    return rumination
  })
  setRumination(ruminations)
  
  const standings=stats&&stats.map(item=>{
    const {standing}=item;
    return standing
  })
  setStanding(standings);

  const packetCounters=stats&&stats.map(item=>{
    const {packetCounter}=item
    return packetCounter
  })
  setPacketCounter(packetCounters);

  const batteryLevels=stats&&stats.map(item=>{
    const {batteryLevel}=item
    return batteryLevel
  })
  setBatteryLevel(batteryLevels);

  const tempratures=stats&&stats.map(item=>{
    const {temperature
    }=item;
    return temperature
    ;
  })
  setTemprature(tempratures);

  const humiditys=stats&&stats.map(item=>{
    const {humidity}=item
    return humidity
  })
  setHumidity1(humiditys);

  const chewings=stats&&stats.map(item=>{
    const {chewing}=item;
    return chewing
  })
  setChewing(chewings);

  const sleepings=stats&&stats.map(item=>{
    const {sleeping}=item;
    return sleeping
  })
  setSleeping(sleepings);

  const walkings=stats&&stats.map(item=>{
    const {walking}=item;
    return walking
  })
  setWalking(walkings);

  const activitys=stats&&stats.map(item=>{
    const {activity}=item;
    return activity
  });
  setActivity(activitys);

  const unrests=stats&&stats.map(item=>{
    const {unrest}=item;
    return unrest
  });
  setUnrest(unrests)

  const tim= stats&&stats.map(item=>{
    const {intervalTime}=item;
   const day=moment(intervalTime).format(`jDD`)
   const time=moment(intervalTime).format(`HH`)
    return `${day}\n${time}`
  })
  setTi(tim)
  const timf= stats&&stats.map(item=>{
    const {logTime}=item;
   const day=moment(logTime).format(`jMM/jDD`)
   const time=moment(logTime).format(`HH:MM`)
    return `${day}\n${time} `
  })
  setTimeFormat(timf)
},[stats])



  useEffect(()=>{
    setOptions({
      
      
      color: colors,
      // tooltip: {
      //   trigger: 'axis',
      //   valueFormatter: (timeformat) => '$' + value.toFixed(2)
        
      // },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        }
        
      },
      grid: {
        
      },
     
      legend: {
        align:'right',
        data: ['packetCounter : ','batteryLevel : ','standing : ','temprature : ','humidity : ','chewing : ','sleeping : ','rumination : ','walking : ','activity : ','unrest : ']
      },
      xAxis: [
        {
          type: 'category',
          axisTick: {
            alignWithLabel: true
          },
          
          // prettier-ignore
          data: timeformat
        },
      
      ],
      dataZoom: [
        {
          type: 'slider',
          show: true,
          
          start: 85,
          end: 100
        },
        {
          start: 80,
          type: "inside"
        },
      ],
        
      yAxis: [
        
        {
          type: 'value',
          name: 'دقیقه',
          position: 'left',
          alignTicks: true,
          axisLine: {
            show: true,
            lineStyle: {
              color: colors[2]
            }
          },
          axisLabel: {
            formatter: '{value} '
          }
        }
      ],
     
      series: [
        {
          name: 'packetCounter : ',
          type: 'line',
          yAxisIndex: 0,

          data: packetCounter1
        },
        {
          name: 'batteryLevel : ',
          type: 'line',
          yAxisIndex: 0,
          
          data: batteryLevel1
        },{
          name:'temprature : ',
          type:'line',
          data:temprature1
        },
        {
          name:'humidity : ',
          type:'line',
          data:humidity1
        },{
          name:'chewing : ',
          type:'line',
          data:chewing1
        },{
          name:'sleeping : ',
        type:'line',
      data:sleeping1    },
      {
        name:'rumination : ',
        type:'line',
        data:rumination1
      },{
        name:'walking : ',
        type:'line',
        data:walking1
      },{
        name:'activity : ',
        type:'line',
        data:activity1
      },{
        name:'unrest : ',
        type:'line',
        data:unrest1
      }
        
      ],
      
    })
  },[standing1,packetCounter1,batteryLevel1,temprature1,humidity1,chewing1,sleeping1,rumination1,walking1,activity1,unrest1])


  const [options, setOptions] = useState({
    dataZoom: [
      {
        type: 'inside',
        throttle: 50
      }
    ],
    color: colors,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      }
    },
    grid: {
      
    },
   
    legend: {
      align:'right',
      data:  ['packetCounter : ','batteryLevel : ','standing : ','temprature : ','humidity : ','chewing : ','sleeping : ','rumination : ','walking : ','activity : ','unrest : ']
    },
    xAxis: [
      {
        type: 'category',
        axisTick: {
          alignWithLabel: true
        },
        // prettier-ignore
        data: newArr
      },
    
    ],
    dataZoom: [
      {
        type: 'slider',
        show: true,
        
        start: 85,
        end: 100
      }],
    yAxis: [
      
      {
        type: 'value',
        name: 'دقیقه',
        position: 'left',
        alignTicks: true,
        axisLine: {
          show: true,
          lineStyle: {
            color: colors[2]
          }
        },
        axisLabel: {
          formatter: '{value} دقیقه'
        }
      },
      
    ],
    series: [
      {
        name: 'packetCounter : ',
        type: 'line',
        yAxisIndex: 0,

        data: packetCounter1
      },
      {
        name: 'batteryLevel : ',
        type: 'line',
        yAxisIndex: 0,
        
        data: batteryLevel1
      },{
        name:'temprature : ',
        type:'line',
        data:temprature1
      },
      {
        name:'humidity : ',
        type:'line',
        data:humidity1
      },{
        name:'chewing : ',
        type:'line',
        data:chewing1
      },{
        name:'sleeping : ',
      type:'line',
    data:sleeping1   },
    {
      name:'rumination : ',
      type:'line',
      data:rumination1
    },{
      name:'walking : ',
      type:'line',
      data:walking1
    },{
      name:'activity : ',
      type:'line',
      data:activity1
    },{
      name:'unrest : ',
      type:'line',
      data:unrest1
    }
      
    ],
	});	

	return (
    <ECharts
    
			option={options}
      opts={{ renderer: 'svg', width: 'auto', height: '400px' }}
    />
  );
}
export default StChartPacket